export default function Footer() {
    return (
        <div>
            <footer className="footer">
                <div className="row">
                    <div className="col-sm-12 col-md-12 col-lg-12">
                        <a target="_blank" rel="noreferrer" href="https://societynotebook.com">
                            www.societynotebook.com
                        </a>
                    </div>
                </div>
            </footer>
        </div>
    );
}
